import React from "react";
import type { CheckoutLegalLinksConfig } from "./checkoutConfig";
import {
  buildLegalConsentPhrase,
  type LegalConsentLocale,
} from "./checkoutLegalConsentText";

interface Props {
  legalLinks: CheckoutLegalLinksConfig;
  locale: string;
}

export default function CheckoutLegalConsentLinks({
  legalLinks,
  locale,
}: Props) {
  const resolvedLocale: LegalConsentLocale = locale === "en" ? "en" : "et";
  const { segments } = buildLegalConsentPhrase(resolvedLocale, legalLinks);

  return (
    <div className="mt-2 links-green">
      {segments.map((segment, index) => {
        if (segment.type === "link") {
          return (
            <a
              key={`${segment.href}-${index}`}
              href={segment.href}
              target="_blank"
              rel="noopener noreferrer"
              className="color-primary"
            >
              {segment.value}
            </a>
          );
        }
        return <React.Fragment key={`text-${index}`}>{segment.value}</React.Fragment>;
      })}
    </div>
  );
}
